/**
 * @generated SignedSource<<e0e1209e240f581b24a024a856785ca4>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "assignmentTypeId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "assignmentTypeId"
                }
            ],
            "concreteType": "AssignmentType",
            "kind": "LinkedField",
            "name": "assignmentType",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disabledDate",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssignmentTypeStatusUpdateModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssignmentTypeStatusUpdateModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "c123daebb513e26e802a5c1abf3858f3",
            "id": null,
            "metadata": {},
            "name": "AssignmentTypeStatusUpdateModalQuery",
            "operationKind": "query",
            "text": "query AssignmentTypeStatusUpdateModalQuery(\n  $assignmentTypeId: ID!\n) {\n  assignmentType(id: $assignmentTypeId) {\n    disabledDate\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "22801081dd8d5015f96820114d052532";
export default node;
